import React, { useState ,useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { Button, Checkbox, Col, Input, Row, Table,Space,Form ,message} from "antd";
import { components, getRowClassName } from "../../../utils/utils";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { render } from "@testing-library/react";
import { AiOutlineRight } from "react-icons/ai";
import RoleRequest from "./RoleRequest";

// const onChange = (checkedValues) => {
//     console.log("checked = ", checkedValues);
//   };

  // Checkbox change handler
  const handleCheckboxChange = (rowId, selectedValue, setSelectedCheckboxes) => {
    setSelectedCheckboxes((prevState) => ({
      ...prevState,
      [rowId]: selectedValue, // Only one checkbox can be selected at a time
    }));
  };

const columns = (selectedCheckboxes, setSelectedCheckboxes) => [
    // {
    //   title: "S No.",
    //   dataIndex: "sno",
    //   key: "sno",
    // },
    {
      title: "Module Name",
      dataIndex: "moduleName",
      key: "moduleName",
      width: 400,
    },
    {
      title: "View",
      dataIndex: "view",
      key: "view",
      width: 160,
      render: (_, record) => (
        <Checkbox
        checked={selectedCheckboxes[record.id] === "view"}
        onChange={() => handleCheckboxChange(record.id, "view", setSelectedCheckboxes)}
      />
      ),
    },
    {
      title: "View | Add",
      dataIndex: "viewAdd",
      key: "viewAdd",
      render: (_, record) => (
        <Checkbox
        checked={selectedCheckboxes[record.id] === "viewAdd"}
        onChange={() => handleCheckboxChange(record.id, "viewAdd", setSelectedCheckboxes)}
      />
      ),
    },
    {
      title: "View | Edit",
      dataIndex: "viewEdit",
      key: "viewEdit",
      render: (_, record) => (
        <Checkbox
        checked={selectedCheckboxes[record.id] === "viewEdit"}
        onChange={() => handleCheckboxChange(record.id, "viewEdit", setSelectedCheckboxes)}
      />
      ),
    },
    {
      title: "View | Edit | Add",
      dataIndex: "viewEditAdd",
      key: "viewEditAdd",
      width: 180,
      render: (_, record) => (
        <Checkbox
        checked={selectedCheckboxes[record.id] === "viewEditAdd"}
        onChange={() => handleCheckboxChange(record.id, "viewEditAdd", setSelectedCheckboxes)}
      />
      ),
    },
    {
      title: "View | Edit | Add | Delete",
      dataIndex: "viewEditAddDelete",
      key: "viewEditAddDelete",
      width: 200,
      render:  (_, record) => (
        <Checkbox
        checked={selectedCheckboxes[record.id] === "viewEditAddDelete"}
        onChange={() => handleCheckboxChange(record.id, "viewEditAddDelete", setSelectedCheckboxes)}
      />
      ),
    },
    
  ];
  
  const labList = [
    {
      id: 1,
      moduleName: "Customer Management",
    },
    {
      id: 2,
      moduleName: "Categories & Services Management",
    },
    {
      id: 3,
      moduleName: "Comments & Rating Management",
    },
    {
      id: 4,
      moduleName: "App Setting Management",
    },
 
    {
      id: 5,
      moduleName: "Salons Management",
    },
  
      {
        id: 6,
        moduleName: "Appoinments Management",
      },
  
      {
        id: 7,
        moduleName: "User Management",
      },
  ];



export const ViewRole = () => {
    const [loading, setLoading] = useState(false);
    const [selectedCheckboxes, setSelectedCheckboxes] = useState({});
    const navigate = useNavigate();
    const [totalRecords, setTotalRecords] = useState(0);
    // const [labList, setLabList] = useState([]);
    const initialFilter = { page: 1, limit: 10 };
    const [filter, setFilter] = useState(initialFilter);
 

    // const fetchRoleList = () => {
    //   setLoading(true);
    //   RoleRequest.createPermissionRole()
    //     .then((response) => {
    //       const rawData = response?.data?.data || [];
    //       console.log(rawData)
    //       const totalCount = response?.data?.total || 0;
    //       setLabList(rawData)
    //       setTotalRecords(totalCount)
    //     })
    //     .catch((error) => {
    //       message.error("Failed to fetch salon list")
    //       console.log("error", error)
    //     })
    //     .finally(() => {
    //       setLoading(false)
    //     })
  
    // }
  
    // useEffect(() => {
    //   fetchRoleList();
    // }, [filter])



  return (
     <>
      <div>
      <Form.Item className=" submit-btn">
                    <Space>
                        <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} disabled={loading}>
                            <ArrowLeftOutlined />
                        </Button>
                    </Space>
                </Form.Item>
        <Row gutter={[8, 8]} justify="space-between" align="middle">
          <Col>
            <h1 className="app-heading-med">Role Details</h1>
          </Col>
          <Col style={{ gap: "5px" }}></Col>
        </Row>
      </div>
      {/* <div className="subscription-plan" style={{marginTop:'30px'}}>
        <Input size="large" placeholder="Enter Permissions Name" />
      </div> */}
      <div style={{ marginTop: "20px" }}>
        <Table
          size="middle"
          bordered
          rowClassName={getRowClassName}
          components={components}
          columns={columns(selectedCheckboxes, setSelectedCheckboxes)}
          loading={loading}
          dataSource={labList}
          pagination={false}
          rowKey="id"
        />
      </div>
      <div className="bottom-button">
            <div style={{ padding: "10px" }}>
              <Button type="primary" onClick={() => console.log()}>
                Save & Proceed
                <span>
                  <AiOutlineRight/>
                </span>
              </Button>
            </div>
          </div>
    </>
  )
}
